import { Typography, Stack, Chip, TableContainer } from '@mui/material';
import EngagementNestedCard from 'src/components/reports/scheduled-report-cards/engagement-nested-card';
import NestedCard from 'src/components/reports/scheduled-report-cards/nested-card';
import { CommonHelper } from 'src/utils/commonHelper';
import { CommonFunction } from 'src/utils/commonFunctions/common-function.component';
import Charts from './scheduled-report-cards/charts';

const CustomScheduledReportBodyComponent = ({ customReportData, subReportId }) => {

  const summaryFilter = subReportId
    ? customReportData?.report_cards?.filter((report) => report.report_card_details.id === parseInt(subReportId))
    : customReportData?.report_cards?.filter((report) => report.report_card_details.is_display);
  const renderComponent = (data) => {
    switch (data.report_card_details.card_type) {
      case 'nested_card':
        return (
          <Stack spacing={2} direction="column">
            <Stack spacing={2} direction="row" alignItems="center">
              {' '}
              {CommonFunction.InitialReportAccountBadgeWithName(data)}
              <Typography variant="h5" gutterBottom>
                {data.profile_name} : {data.report_card_details.card_name}
              </Typography>
              <Chip
                label={`${CommonHelper.formateDateWithYear(
                  customReportData.start_date
                )} - ${CommonHelper.formateDateWithYear(customReportData.end_date)}`}
                color="primary"
              />
            </Stack>
            <NestedCard
              connectedProfileId={data.connected_profile_id}
              startDate={customReportData.start_date}
              endDate={customReportData.end_date}
              viewBy={customReportData.view_by}
              audienceSummary={data.report_card_details}
              serviceName={data.service_name}
              reportId={customReportData.id}
              isCustomReport={true}
            />
          </Stack>
        );
      case 'chart':
        return (
          <Stack spacing={2} direction="column">
            <Stack spacing={2} direction="row" alignItems="center">
              {' '}
              {CommonFunction.InitialReportAccountBadgeWithName(data)}
              <Typography variant="h5" gutterBottom>
                {data.profile_name} : {data.report_card_details.card_name}
              </Typography>
              <Chip
                label={`${CommonHelper.formateDateWithYear(
                  customReportData.start_date
                )} - ${CommonHelper.formateDateWithYear(customReportData.end_date)}`}
                color="primary"
              />
            </Stack>
            <Charts
              connectedProfileId={data.connected_profile_id}
              startDate={customReportData.start_date}
              endDate={customReportData.end_date}
              viewBy={customReportData.view_by}
              audienceSummary={data.report_card_details}
              serviceName={data.service_name}
              reportId={customReportData.id}
              isCustomReport={true}
            />
          </Stack>
        );
      case 'nested_card_and_table':
        return (
          <Stack spacing={2} direction="column" sx={{ mt: 1 }}>
            <Stack spacing={2} direction="row" alignItems="center">
              {' '}
              {CommonFunction.InitialReportAccountBadgeWithName(data)}
              <Typography variant="h5" gutterBottom>
                {data.profile_name} : {data.report_card_details.card_name}
              </Typography>
              <Chip
                label={`${CommonHelper.formateDateWithYear(
                  customReportData.start_date
                )} - ${CommonHelper.formateDateWithYear(customReportData.end_date)}`}
                color="primary"
              />
            </Stack>

            <EngagementNestedCard
              connectedProfileId={data.connected_profile_id}
              startDate={customReportData.start_date}
              endDate={customReportData.end_date}
              viewBy={customReportData.view_by}
              engagementSummary={data.report_card_details}
              serviceName={data.service_name}
              reportId={customReportData.id}
              isCustomReport={true}
            />
          </Stack>
        );
      default:
        return null;
    }
  };

  return (
    <TableContainer sx={{ mt: 1, height: 'auto', overflow: 'visible' }}>
      {summaryFilter && summaryFilter?.map((data) => renderComponent(data))}
    </TableContainer>
  );
};

export default CustomScheduledReportBodyComponent;
